<template>
  <div @click="toggleMenu">
    <slot></slot>
  </div>
</template>

<script>
import { tremfya as tremfyaMenuItems } from '@/data/sections';
import { psoriasis as psoriasisMenuItems } from '@/data/sections';
import { findIndex, isEqual, debounce } from 'lodash';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      wheelFunc: null
    };
  },
  watch: {
    '$store.state.currentRoute'(val) {
      this.$router.push(val);
    },
    $route: {
      handler: function(value) {
        this.$store.commit('setCurrentSection', {
          section: value.params.section + '',
          subsection: value.params.subsection + ''
        });
        //this.scrollContentTop();
      },
      immediate: true
    }

    // '$store.state.wheelEvent'(event) {
    //   this.debounceWheelHandlerContent(event);
    // }
  },
  computed: {
    ...mapState(['userAgent']),
    slidesCount() {
      return this.linksArray.length;
    },
    currentList() {
      return this.$route.meta.page === 'Tremfya'
        ? tremfyaMenuItems
        : psoriasisMenuItems;
    },
    linksArray() {
      return this.sectionLinksArr(this.currentList);
    },
    activeSlideIndex() {
      // if (this.$store.state.explicitSlideIndex != null) {
      //   return this.$store.state.explicitSlideIndex + 2;
      // }

      let currentRoute = {
        name: this.$route.name,
        params: { ...this.$route.params }
      };

      console.log(currentRoute);
      if (this.$store.state.explicitSlideIndex != null) {
        currentRoute.params.subsection =
          this.$store.state.explicitSlideIndex + 1 + '';
      }
      // console.log(currentRoute);
      return findIndex(this.linksArray, obj => isEqual(obj, currentRoute));
    }
  },
  methods: {
    setRouteExplicit(section, subsection) {
      if (typeof subsection === typeof undefined) {
        subsection = '';
      }
      // this.$router.push('/tremfya/' + section + '/' + subsection);
      console.log('->', section, subsection);
      this.$store.commit('setCurrentSection', {
        section: section + '',
        subsection: subsection + ''
      });
    },
    // onWheel(e) {
    //   if (
    //     !this.userAgent.screentest &&
    //     this.$store.state.contentTitleScrollLock === true &&
    //     !this.$store.state.targetIsIsi
    //   ) {
    //     // if (this.userAgent.isScrollLock === true) {
    //     // console.log('locked', this.$store.state.contentTitleScrollLock);
    //     // if (this.$store.state.contentTitleScrollLock === true) {
    //     console.log('-- scroll is locked, no wheel!');
    //     return;
    //   }

    //   if (
    //     this.$store.state.headerStatus === 'title' &&
    //     e.direction === 'up' &&
    //     !this.$store.state.targetIsIsi
    //   ) {
    //     this.pushPrevSlide();
    //   }
    //   // else {
    //   //   this.$store.commit('setContentTitleScrollLock', false);
    //   // }

    //   if (
    //     this.$store.getters.canScroll &&
    //     !this.$store.getters.hasContent &&
    //     !this.$store.state.targetIsIsi
    //   ) {
    //     e.direction === 'down' ? this.pushNextSlide() : this.pushPrevSlide();
    //   } else {
    //     if (
    //       this.$store.state.headerStatus !== 'basic' &&
    //       !this.$store.state.targetIsIsi
    //     ) {
    //       this.$store.commit('setHeaderStatus', 'basic');
    //     } else {
    //       if (!this.isScrollable && !this.$store.state.targetIsIsi) {
    //         e.direction === 'down'
    //           ? this.pushNextSlide()
    //           : this.pushPrevSlide();
    //       } else {
    //         // indicator.setOptions({ preventMouse: false });
    //         e.direction === 'up' && this.onScroll();
    //       }
    //     }
    //   }
    // },
    pushNextSlide() {
      if (
        this.activeSlideIndex !== this.slidesCount - 1 &&
        this.$store.state.btnScroll === false
      ) {
        // this.lockScroll();
        this.$store.commit(
          'setRouteFromObj',
          this.linksArray[this.activeSlideIndex + 1]
        );
        return;
      }
    },
    pushPrevSlide() {
      if (this.activeSlideIndex !== 0) {
        // this.lockScroll();
        this.$store.commit(
          'setRouteFromObj',
          this.linksArray[this.activeSlideIndex - 1]
        );
        return;
      }
    },
    sectionLinksArr(sections) {
      let arr = [];
      sections.forEach((el, i) => {
        arr.push({
          name: `${this.$route.meta.page}-section`,
          params: { section: `${i + 1}` }
        });
        if (el.subsections) {
          el.subsections.forEach((el, j) => {
            arr.push({
              name: `${this.$route.meta.page}-subsection`,
              params: { section: `${i + 1}`, subsection: `${j + 1}` }
            });
          });
        }
      });
      return arr;
    },
    toggleMenu() {
      if (this.$store.state.headerStatus !== 'basic') {
        this.$store.commit('setHeaderStatus', 'basic');
      }
    },

    scrollContentTop() {
      this.$nextTick(() => {
        let content = document.querySelector('.js-content');

        if (content) {
          document.querySelector('.js-content').scrollTo(0, 0);
        } else {
          console.warn(
            '.js-content is undefined! Called in scrollContentTop method'
          );
        }
      });
    },

    handleScroll(scrollDown = true) {
      if (!this.$store.state.targetIsIsi && !this.userAgent.isScrollLock) {
        if (
          this.$route.params.section &&
          !this.$route.params.subsection &&
          this.$store.state.headerStatus === 'menu'
        ) {
          let list = this.currentList;
          let hasContent =
            list[findIndex(list, ['number', this.$route.params.section])]
              .content;

          if (!hasContent) {
            if (scrollDown === true) {
              this.pushNextSlide();
            } else {
              this.pushPrevSlide();
            }
          } else {
            if (scrollDown === false) {
              this.pushPrevSlide();
            } else {
              this.$store.commit('setHeaderStatus', 'basic');
            }
          }
          return;
        }

        if (
          this.$store.state.headerStatus === 'menu' ||
          this.$store.state.headerStatus === 'openSubmenu'
        ) {
          this.$store.commit('setHeaderStatus', 'basic');
          return;
        }

        let cont = document.querySelector('.js-content');

        if (scrollDown === true) {
          // console.log('--- SCROLL DOWN ---');

          let remaining = Math.abs(
            parseInt(cont.scrollHeight) -
              parseInt(window.innerHeight) -
              parseInt(cont.scrollTop)
          );

          // console.log('ContentScroll Remaining', remaining);

          if (this.$store.state.headerStatus === 'title') {
            this.$store.commit('setHeaderStatus', 'basic');
          } else if (remaining < 2) {
            this.pushNextSlide();
          }
        } else if (scrollDown === false) {
          // console.log('--- SCROLL UP ---');

          // if we are up and see subsec title
          if (
            this.$store.state.headerStatus === 'title' ||
            cont.scrollTop === 0
          ) {
            this.pushPrevSlide();
          }
        }
      }
    },
    handleWheel(e) {
      console.warn('Handle wheel');
      this.handleScroll(e.deltaY > 0 ? true : false);
    },

    debounceWheelHandlerContent(e) {
      // console.log('--- SCROLL ---');
      if (!this.$store.state.targetIsIsi && !this.userAgent.isScrollLock) {
        let cont = document.querySelector('.js-content');

        if (
          cont.scrollHeight - window.innerHeight === cont.scrollTop &&
          e.deltaY > 0
        ) {
          // console.log('--- SCROLL DOWN ---');
          this.pushNextSlide();
        } else if (cont.scrollTop === 0 && e.deltaY < 0) {
          // console.log('--- SCROLL UP ---');
          this.pushPrevSlide();
        }
      }
    },
    debounceWheelHandlerHeader(e) {
      // console.log('--- SCROLL HEADER ---');
      this.handleScroll(e.deltaY > 0 ? true : false);
    }
    // onKeypress(e) {
    //   if (e.keyCode === 38) {
    //     this.handleScroll(false);
    //   }
    //   if (e.keyCode === 40) {
    //     this.handleScroll(true);
    //   }
    // }
  },
  mounted() {
    this.wheelFunc = debounce(this.debounceWheelHandlerHeader, 50, {
      leading: true,
      trailing: false
    });

    // window.addEventListener('keydown', this.onKeypress);
    document.addEventListener('wheel', this.wheelFunc);
  },
  beforeDestroy() {
    // document.removeEventListener('keydown', this.onKeypress);
    document.removeEventListener('wheel', this.wheelFunc);
  }
};
</script>
